import { Client, ContractType } from "../clients/store";

export const isClientPremium = (client: Client | undefined | null) => {
  if (!client) return false;
  return client.contract.contractName !== ContractType.DEMO;
};
